import type { ReactNode } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { get } from '../lib/api';
import { useAuth, useMe } from '../lib/auth';
import { Badge, Button } from '../ui';
import { t } from '../lib/i18n';
import { LanguageSwitch } from '../ui/LanguageSwitch';

export default function PortalLayout({ children }: { children: ReactNode }) {
  const me = useMe();
  const { logout } = useAuth();
  const nav = useNavigate();
  const notes = useQuery({ queryKey: ['me-notifications'], queryFn: () => get<{ unread: number }>('/api/me/notifications'), refetchInterval: 60_000 });
  return (
    <div className="portal">
      <header className="portal-top">
        <div className="inner">
          <strong className="nowrap">{me.organization?.name ?? t('Iglesia')}</strong>
          <nav className="portal-nav grow" aria-label={t('Portal')}>
            <NavLink to="/portal" end>{t('Inicio')}</NavLink>
            <NavLink to="/portal/programacion">{t('Mi programación')}</NavLink>
            <NavLink to="/portal/checkin">{t('Check-in')}</NavLink>
            <NavLink to="/portal/donar">{t('Donar')}</NavLink>
            <NavLink to="/portal/inscripciones">{t('Inscripciones')}</NavLink>
            <NavLink to="/portal/grupos">{t('Grupos')}</NavLink>
            <NavLink to="/portal/calendario">{t('Calendario')}</NavLink>
            <NavLink to="/portal/mensajes">{t('Mensajes')}</NavLink>
            <NavLink to="/portal/notificaciones">{t('Avisos')}{notes.data?.unread ? <> <Badge tone="blue">{notes.data.unread}</Badge></> : null}</NavLink>
            <NavLink to="/portal/perfil">{t('Mi perfil')}</NavLink>
          </nav>
          {me.isStaff && <Button size="sm" onClick={() => nav('/')}>{t('Panel')}</Button>}
          <LanguageSwitch />
          <Button size="sm" variant="ghost" onClick={async () => { await logout(); nav('/entrar'); }}>{t('Salir')}</Button>
        </div>
      </header>
      <main className="portal-content">{children}</main>
    </div>
  );
}
